import {Component, ElementRef, Input, TemplateRef} from '@angular/core';
import {AppContext} from "../../app-context";
import {checkValidity} from "../utils";

@Component({
  selector: 'modal-confirm-autofocus',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
  host: {
    '[class.modal-confirm-warning]': "data?.type === 'warning'",
  },
})
export class ModalConfirmAutofocus {
  @Input() data: ModalConfirmAutofocusData;
  callback: (result: any, reason?: string) => any;

  constructor(private element: ElementRef) {
  }

  get title() {
    return this.data?.title || "Danger";
  }

  get points() {
    return this.data?.points || [];
  }

  get confirmText() {
    return this.data?.confirmText || "Ok";
  }

  get cancelText() {
    return this.data?.cancelText || "Cancel";
  }

  get alternativeText() {
    return this.data?.alternativeText;
  }

  validateAndSubmit = () => {
    if (!this.data.body || checkValidity(this.element)) {
      this.callback(true);
    }
  }
}

export interface ModalConfirmAutofocusData {
  type: string | 'warning' | 'info' | 'danger';
  title: string;
  modalSize: null | 'sm' | 'lg' | 'xl';
  message: string;
  innerHtmlMessage: string;
  points: string[];
  afterPointsMessage: string;
  question: string;
  innerHtmlQuestion: string;
  confirmText: string;
  cancelText: string;
  alternativeText?: string;
  alternativeValue?: string;
  withReason?: boolean;
  reason?: string;
  body: TemplateRef<any>;
}
